var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dialog',{attrs:{"value":_vm.value,"title":"📅 오늘의 출석","max-width":520,"closable":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_c('AttendancePanel',{on:{"attended":_vm.onAttended}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }